import styled from '@emotion/styled';

interface IChatErrorMessageProps {
  noBackground?: boolean;
}
export const ChatBlockedWarningMessage = styled('div')<IChatErrorMessageProps>`
  color: #5c646b;
  font-weight: 800;
  background-color: ${(props) => (props.noBackground ? 'unset' : '#a0acbc')};
  line-height: 2.2rem;
  font-size: 1.2rem;
  padding: 1rem;
  position: relative;
  width: calc(100% - 2rem); /* minus padding */
  left: 0;
`;

export const BlockedWarningTitle = styled('span')`
  margin-left: 0.4rem;
`;
